export default __webpack_public_path__ + "static/media/airlockz-cbb-2.40a6d7fe.png";